var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14269 5.83333V4C7.14269 3.60218 7.2932 3.22064 7.56111 2.93934C7.82902 2.65804 8.19238 2.5 8.57127 2.5H11.4284C11.8073 2.5 12.1707 2.65804 12.4386 2.93934C12.7065 3.22064 12.857 3.60218 12.857 4V5.83333M15.8332 5.83333L14.9998 16C14.9998 16.3978 14.8493 16.7794 14.5814 17.0607C14.3135 17.342 13.9501 17.5 13.5713 17.5H6.42841C6.04953 17.5 5.68617 17.342 5.41826 17.0607C5.15035 16.7794 4.99984 16.3978 4.99984 16L4.1665 5.83333H15.8332Z",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 5.83398H4.81498H16.6668",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 9.16602V13.3327",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 9.16602V13.3327",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.9a109c70f168eb3e637308d43a1a1c6b.svg";
export { ForwardRef as ReactComponent };